export const TOGGLE_LOADING = 'TOGGLE_LOADING';
export const TOGGLE_ALERT_ERROR = 'TOGGLE_ALERT_ERROR';
export const SWITCH_LANGUAGE = 'SWITCH_LANGUAGE';
export const UPDATE_API_STATUS = 'UPDATE_API_STATUS';
export const UPDATE_SETTINGS = 'UPDATE_SETTINGS';

export const LOGIN_USER = 'LOGIN_USER';
export const LOGOUT_USER = 'LOGOUT_USER';

export const UPDATE_NOTIFICATIONS = 'UPDATE_NOTIFICATIONS';
export const DELETE_NOTIFICATION = 'DELETE_NOTIFICATION';
export const DELETE_ALL_NOTIFICATIONS = 'DELETE_ALL_NOTIFICATIONS';

export const SET_ACTIVE_ACCOUNT = 'SET_ACTIVE_ACCOUNT';
export const OPEN_PHONE_CALL_MODAL = 'OPEN_PHONE_CALL_MODAL';
export const HANG_UP_CALL = 'HANG_UP_CALL';
export const LOAD_CHANNEL = 'LOAD_CHANNEL';
export const RELOAD_CHANNELS_LIST = 'RELOAD_CHANNELS_LIST';

export const WEBSOCKET_CHANGE_STATUS = 'WEBSOCKET_CHANGE_STATUS';
export const WEBSOCKET_CONNECT = 'WEBSOCKET_CONNECT';
export const WEBSOCKET_DISCONNECT = 'WEBSOCKET_DISCONNECT';
export const WEBSOCKET_SEND_MESSAGE= 'WEBSOCKET_SEND_MESSAGE';
export const WEBSOCKET_NEW_MESSAGE= 'WEBSOCKET_NEW_MESSAGE';
export const WEBSOCKET_NEW_MESSAGE_FILE= 'WEBSOCKET_NEW_MESSAGE_FILE';
export const WEBSOCKET_USER_ONLINE= 'WEBSOCKET_USER_ONLINE';
export const WEBSOCKET_USER_OFFLINE= 'WEBSOCKET_USER_OFFLINE';
export const WEBSOCKET_CHECK_USER_ONLINE= 'WEBSOCKET_CHECK_USER_ONLINE';



// WEBPACK FOOTER //
// ./stores/types/common/index.js